module.exports = __webpack_public_path__ + "img/ico-list2.cfce727a.svg";